import CeisaSystemCodeIndex from "@/components/exim/ceisa/system_code/CeisaSystemCodeIndex.vue";
import CeisaSystemCodeDetail from "@/components/exim/ceisa/system_code/CeisaSystemCodeDetail.vue";
import CeisaSystemCodeCreate from "@/components/exim/ceisa/system_code/CeisaSystemCodeCreate.vue";
import CeisaSystemCodeUpload from "@/components/exim/ceisa/system_code/CeisaSystemCodeUpload.vue";
import CeisaSystemCodeEdit from "@/components/exim/ceisa/system_code/CeisaSystemCodeEdit.vue";

let CeisaSystemCodeRoute= [
    {
        path: '',
        meta: {
          title: "Ceisa System Code",
        },
        name: "CeisaSystemCodeIndex",
        component: CeisaSystemCodeIndex
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Ceisa System Code Detail",
        },
        name: "CeisaSystemCodeDetail",
        component: CeisaSystemCodeDetail
    },
     
    {
      path: 'create',
      meta: {
        title: "Ceisa System Code Create",
      },
      name: "CeisaSystemCodeCreate",
      component: CeisaSystemCodeCreate
    },

    {
        path: 'upload',
        meta: {
          title: "Ceisa System Code Upload",
        },
        name: "CeisaSystemCodeUpload",
        component: CeisaSystemCodeUpload
    },

    {
      path: 'edit/:id',
      meta: {
        title: "Ceisa System Code Update",
      },
      name: "CeisaSystemCodeEdit",
      component: CeisaSystemCodeEdit
    },
     
    
]

export default CeisaSystemCodeRoute
  